import store from 'source/store';
import MemorandumsPageGroup from 'src/pages/root/MemorandumsPageGroup.vue';
//memo page for execs without employment and is not org exec
function canAccessMemorandumPage(to, from, next) {
    const isNotOrgExec = !store.state.auth.user.user_profile.is_organizational_exec;
    const hasNoEmployment = !(!!store.state.auth.user.user_profile.employment);
    const canAccess = isNotOrgExec && hasNoEmployment;

    if (canAccess) {
        next();
    } else {
        ({ name: 'access-denied', replace: true });
    }

}

export default [{
    path: 'memorandums/',
    component: MemorandumsPageGroup,
    meta: {
        title: 'Memorandums - HQZen',
        canDisplayGlobalModals: true
    },
    beforeEnter: canAccessMemorandumPage,
    children: [
        {
            path: '',
            name: 'memos',
            component: () => import('source/pages/employment/EmploymentDocumentsPage.vue'),
            props: true,
            meta: {
                title: 'Memorandums - HQZen',
                canDisplayGlobalModals: true,
            },
            children: [
                {
                    path: 'details/:document_id',
                    name: 'memo-details',
                    component: () => import('source/pages/employment/documents/DocumentDetailsPage.vue'),
                    props: true,
                    meta: {
                        title: 'Memorandum - HQZen',
                        canDisplayGlobalModals: true,
                    },
                }
            ]
        },
    ]
}];
